import { IGPSCounts } from '@nkr/models/index';
import { Nav } from 'react-bootstrap';
import { NavItemWrapper, NavWrapper } from './styles';

interface IProps {
    counts: IGPSCounts,
    activeKey: string,
}

const GPSNav = (props: IProps) => {
    const hrefPrefix = `/admin/gps`;

    return (
        <NavWrapper>
            <div style={{ marginBottom: 10, backgroundColor: 'white' }}>
                <Nav bsStyle='pills' className='ms-pills'>
                    <NavItemWrapper active={props.activeKey == 'PENDING-GPS-ASSIGN'} href={hrefPrefix + '/pend-gps-assign'}>
                        Pend GPS Assign <span className='type-count'>({props.counts.pendShip})</span>
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper active={props.activeKey == 'PENDING-JOURNEY'} href={hrefPrefix + '/pending-journey'}>
                        Pending Journey <span className='type-count'>({props.counts.pendingGPS})</span>
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper active={props.activeKey == 'IN-PROCESS'} href={hrefPrefix + '/in-process'}>
                        In Process <span className='type-count'>({props.counts.inProcess})</span>
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper active={props.activeKey == 'RETURN-TO-NKR'} href={hrefPrefix + '/return-to-nkr'}>
                        Pend Return <span className='type-count'>({props.counts.returnToNKR})</span>
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper active={props.activeKey == 'GPS-CENTRAL'} href={hrefPrefix + '/gps-central'}>
                        GPS Central
                    </NavItemWrapper>
                </Nav>
            </div>
        </NavWrapper>
    );
}

export default GPSNav;